var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chat-container"},[_c('iframe',{attrs:{"src":_vm.iframeURL,"height":"100%","width":"100%"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }